import React from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import styled from '@emotion/styled';
import Button from '@atlaskit/button';
import { routePaths } from '@css-xp/ppc-constants';
import { getRouteUrl } from '@css-xp/ppc-utils';

const StyledSuccessContent = styled.div({
  marginTop: '30px',
});

const StyledHomePageButton = styled.div`
  display: flex;
  gap: 10px;
  padding-top: 8px;
  justify-content: center;
  > a > button:hover {
    text-decoration: none;
  }
`;

export const ExistingSiteSuccessContent = ({
  isExistingSiteNewOrderItem,
  isDesignIteration1Enabled,
}: {
  isExistingSiteNewOrderItem?: boolean;
  isDesignIteration1Enabled?: boolean;
}) => {
  const { txaId } = useParams<{ txaId: string }>();
  return (
    <>
      {isExistingSiteNewOrderItem && (
        <StyledSuccessContent>Subscriptions will be added to applicable sites shortly. </StyledSuccessContent>
      )}
      {isDesignIteration1Enabled ? (
        <StyledHomePageButton>
          <Link
            to={getRouteUrl(routePaths.home, {
              txaId: txaId,
            })}
          >
            <Button>Back to homepage</Button>
          </Link>
        </StyledHomePageButton>
      ) : (
        <StyledSuccessContent>You can view your order on Partner Purchasing Center.</StyledSuccessContent>
      )}
    </>
  );
};
